export const APPLY_TO_PROJECT = `project-applications/apply`; //#DONE
export const PROJECT_APPLICATION_IDS = `project-applications/my-applicationIds`; //#DONE

export const ALL_MY_APPLICATIONS = `project-applications/my-applications`; // #!DONE
export const MY_COMPLETED_APPLICATIONS = {
  //#DONE
  APPLICATIONS: (pageNumber) => `project-applications/my-applications?page=${pageNumber}&status=completed`,
};
export const MY_ASSIGNED_APPLICATIONS = {
  //#DONE
  APPLICATIONS: (pageNumber) => `project-applications/my-applications?page=${pageNumber}&status=assigned`,
};
export const WITHDRAW_APPLICATION = `project-applications/withdraw`; // #!DONE
// export const PROJECT_APPLICATION_AND_APPLICANTS = `project-applications/12`;
export const USERS_APPLYING_TO_PROJECT = {
  // #!DONE
  PROJECT_ID: (projectId) => `project-applications/${projectId}`,
};
export const ACCEPT_PROJECT = `project-applications/accept`; // #!DONE